import { Filter } from '@/shared/interfaces/filter'
import { DataSource } from '@/shared/models/data/data-source'
import { StringMap } from '@/shared/utils/map'

export abstract class Paginator<T> {
  public abstract filter: Filter

  abstract get filtered(): number
  abstract get items(): T[]
  abstract get total(): number

  public abstract page: number
  public abstract pageSize: number

  public abstract changePage(page: number): this
  public abstract changePageSize(pageSize: number): this

  public abstract initialize(dataSource?: DataSource<T>): Promise<T[]>

  public abstract isInitializing(): boolean
  public abstract isSearching(): boolean

  public abstract categories(categories?: StringMap<boolean>): this
  public abstract query(term?: string): this

  public abstract reset(): this

  /**
   * Update items
   */
  public abstract update(): Promise<T[]>
}
